import { BitkitAlert } from '@bitrise/bitkit-v2';
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const ErrorNotification = () => <BitkitAlert variant="critical" messageText="Failed to load logs." />;

const BuildLogErrorBoundary = ({ children }: { children: ReactNode }) => {
  return <ErrorBoundary FallbackComponent={ErrorNotification}>{children}</ErrorBoundary>;
};

export default BuildLogErrorBoundary;
